// extracted by mini-css-extract-plugin
export default {"root":"ItemViewer__root--28WAn","content":"ItemViewer__content--2VyjQ","contentMessage":"ItemViewer__contentMessage--9uLSu","wrapper":"ItemViewer__wrapper--3_8Ei"};